function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
// import { isEmailValid } from "@limitless/customer/utils";
import { isFieldEmpty } from "@limitless/common/utils";
import CheckTextField from "./CheckTextField";
const ShortTextField = ({
  check,
  onChange,
  ...rest
}) => {
  const {
    isInvalid = false
  } = check;
  const validateShortTextAndUpdate = newValue => {
    let isInvalid = false;
    if (isFieldEmpty(newValue) || newValue.length > 20) {
      isInvalid = true;
    }
    onChange(newValue, isInvalid);
  };
  return /*#__PURE__*/React.createElement(CheckTextField, _extends({}, rest, {
    check: check,
    onChange: validateShortTextAndUpdate,
    helperText: isInvalid ? "Must be 20 characters or less" : null,
    placeholder: "Type here..."
  }));
};
export default ShortTextField;
ShortTextField.propTypes = {
  check: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};